import _ from 'lodash'
import createFormActions from "./create-form-actions"


const _initialState = getFormInitialState()


export function getFormInitialState() {
    return {
        values: {},
        valid: true,
        dirty: false,
        errorMessages: {},
        dirtyFields: {},
        showValidationErrors: false,

    }
}

export default function createFormReducer(formName, validator = () => true, initialState = _initialState) {

    const {changeValue, reset, validate, patchValues} = createFormActions(formName)
    const changeValueType = changeValue().type
    const resetType = reset().type
    const validateType = validate().type
    const patchValuesType = patchValues().type

    return function (state = initialState, {type, payload}) {

        let errorMessages

        switch (type) {

            case validateType:
                errorMessages = validator(state.values)

                return {
                    ...state,
                    valid: Object.keys(errorMessages).length === 0,
                    errorMessages,
                    showValidationErrors: true,
                }

            case changeValueType:
                const values = _.set({...state.values}, payload.inputName, payload.value)
                errorMessages = validator(values)

                return {
                    ...state,
                    values,
                    dirty: true,
                    valid: Object.keys(errorMessages).length === 0,
                    errorMessages,
                    dirtyFields: {
                        ...state.dirtyFields,
                        [payload.inputName]: true,
                    }
                }

            case patchValuesType:

                return {
                    ...state,
                    values: payload
                }

            case resetType:
                return {
                    ...initialState,
                }

            default:
                return state
        }


    }
}


// WEBPACK FOOTER //
// ./src/redux/actions-reducers/form/create-form-reducer.js